<template>
  <CCardBody>
    <div>
      <strong>General Settings</strong>
    </div>
    <template v-if="$can('view-general-settings')">
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="measurement_unit" label-for="measurement_unit">
                <label class="required">Measurement Unit</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="measurement_unit" label-for="measurement_unit">
                <v-select :clearable="false"
                    id="measurement_unit"
                    :options="[{id:'cm', label:'Centimeters'},{id:'in', label:'Inches'}]"
                    name="measurement_unit"
                    v-model="general_form.measurement_unit"
                    placeholder="Select Measurment Unit"
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="mail_recipients">
                <label class="required">Mail's Recipients</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="mail_recipients" label-for="mail_recipients">
                <v-select :clearable="false"
                    multiple
                    id="mail_recipients"
                    :options="user_recipients_options"
                    name="mail_recipients"
                    v-model="general_form.mail_recipients"
                    placeholder="Select Mail Recipients"
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <template v-if="company && !isEcommercePlatform() ">
        <div class="row mt-2" >
          <div class="col-12">
            <div class="row">
              <div class="col-md-3 my-1">
                <b-form-group id="get_quote_label" label-for="get_quote">
                  <label>Enable "get a quote" button in builder</label>
                </b-form-group>
              </div>
              <div class="col-md-6 my-1">
                <b-form-group id="get_quote" >
                  <b-form-checkbox @change="setQuoteRecipients()" v-model="general_form.get_quote" name="get_quote" switch></b-form-checkbox>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <template v-if="general_form.get_quote">
          <div>
            <div class="row mt-2" >
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group label-for="quote_recipients">
                      <label class="required">Get a quote mail Recipients</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-group id="quote_recipients" label-for="quote_recipients">
                      <v-select :clearable="false"
                                multiple
                                id="quote_recipients"
                                :options="user_recipients_options"
                                name="quote_recipients"
                                v-model="general_form.quote_recipients"
                                placeholder="Select Quote Recipients"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" >
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group id="cart_with_quote_label" label-for="cart_with_quote">
                      <label>Enable "cart with quote"</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-group id="cart_with_quote" >
                      <b-form-checkbox v-model="general_form.cart_with_quote" name="cart_with_quote" switch></b-form-checkbox>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </template>


      </template>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="color_type" label-for="color_type">
                <label class="required">Match customizer colors to: </label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="color_type" label-for="color_type">
                <v-select
                    id="color_type"
                    @input="setLogoColorType"
                    :options="color_type_options"
                    name="color_type"
                    v-model="general_form.color_type"
                    placeholder="Select Color Type"
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" >
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group  label-for="allow_shuffle_colors">
                <label class="required">Shuffle colors on all products</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="allow_shuffle_colors" >
                <b-form-checkbox v-model="general_form.allow_shuffle_colors" name="allow_shuffle_colors" switch></b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" >
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group  label-for="auto_order_approval">
                <label class="required">Automatically approve all incoming orders</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="auto_order_approval" >
                <b-form-checkbox v-model="general_form.auto_order_approval" name="auto_order_approval" switch></b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" >
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="currency" label-for="allow_custom_color">
                <label class="required">Allow Custom Color</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="allow_custom_color" >
                <b-form-checkbox v-model="general_form.allow_custom_color" name="allow_custom_color" switch></b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" >
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="currency" label-for="allow_custom_color">
                <label class="required">Ship only to store</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="ship_only_to_store" >
                <b-form-checkbox v-model="general_form.ship_only_to_store" name="ship_only_to_store" switch></b-form-checkbox>
              </b-form-group>
              <div v-if="general_form.ship_only_to_store" class="row">
                <div class="w-100">
                  <div class="form-holder theme-scroll-v" style="overflow: hidden; overflow-y: auto;">
                    <div class="form-area add-address p-4">
                      <b-form>
                        <div>
                          <div style="gap: 15px;" class="d-flex justify-content-between">
                            <div class="w-50">
                              <b-form-group
                                  label="First Name *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.first_name"
                                    placeholder="First Name"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Email"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.email"
                                    placeholder="Email"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Address *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.address1"
                                    placeholder="Address"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="City *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.city"
                                    placeholder="City"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Country *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-select
                                    v-model="general_form.store_address.country"
                                    :options="getCountries"
                                    class="mb-3"
                                    value-field="id"
                                    text-field="label"
                                    disabled-field="notEnabled"
                                ></b-form-select>
                              </b-form-group>
                              <b-form-group
                                  label="State/Province"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.state"
                                    placeholder="State/Province"
                                    required
                                ></b-form-input>
                              </b-form-group>
                            </div>
                            <div class="w-50">
                              <b-form-group
                                  label="Last Name *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.last_name"
                                    placeholder="Last Name"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Phone Number *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.phone_number"
                                    placeholder="Phone Number"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Second Address"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.address2"
                                    placeholder="Second Address"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Zip Code *"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.zip_code"
                                    placeholder="Zip Code"
                                    required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                  label="Company Name"
                                  label-for="input-1" class="text-left"
                              >
                                <b-form-input
                                    type="text"
                                    v-model="general_form.store_address.company_name"
                                    placeholder="Company Name"
                                    required
                                ></b-form-input>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="logo_color_type" label-for="logo_color_type">
                <label class="required">Match logo colors for production to:</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="logo_color_type" label-for="logo_color_type">
                <v-select :clearable="false"
                          id="logo_color_type"
                          :options="santaClone(color_type_options)"
                          name="logo_color_type"
                          v-model="general_form.logo_color_type"
                          placeholder="Select Logo Color Type"
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="necktag_logo_label" label-for="piping_text">
                <label class="required">Neck tag logo</label>
              </b-form-group>
            </div>
            <div class="image-holder flex-shrink-0" style="width:170px;"
                 :class="errors && errors.first('necktag_logo_image') ? 'v-image' : ''">
              <img v-if="general_form.necktag_logo.url == ''"
                   class="default-logo border border-secondary rounded-sm cursor-pointer w-100"
                   @click="$bvModal.show('necktag_logo_modal')"
                   src="../../assets/images/dummy-t.png"/>
              <img v-else
                   class="selected_logo border border-secondary p-2 rounded-sm cursor-pointer w-100"
                   @click="$bvModal.show('necktag_logo_modal')"
                   :src="base_url+'/'+general_form.necktag_logo.url" style="width:100%;height:100%"/>
              <CInput
                  addLabelClasses="required"
                  placeholder="height"
                  type="hidden"
                  v-model="general_form.necktag_logo.url"
                  name="necktag_logo_image"
                  id="necktag_logo_image"
              >
              </CInput>
            </div>
            <div class="col-md-3 ">
              <b-button @click="removeNeckTagLogo(general_form.necktag_logo.file_id)" variant="danger">Remove Logo</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="piping_text" label-for="piping_text">
                <label class="required">Piping text</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="piping_text" label-for="piping_text">
                <b-form-input
                    type="text"
                    v-model="general_form.piping_text"
                    placeholder="Enter piping information"
                >
                </b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group id="carelabel_label" label-for="piping_text">
                <label class="required">Carelabel</label>
              </b-form-group>
            </div>
            <div class="image-holder flex-shrink-0" style="width:170px;"
                 :class="errors && errors.first('carelabel_image') ? 'v-image' : ''">
              <img v-if="general_form.carelabel.url == ''"
                   class="default-logo border border-secondary rounded-sm cursor-pointer w-100"
                   @click="$bvModal.show('carelabel_modal')"
                   src="../../assets/images/dummy-t.png"/>
              <img v-else
                   class="selected_logo border border-secondary p-2 rounded-sm cursor-pointer w-100"
                   @click="$bvModal.show('carelabel_modal')"
                   :src="base_url+'/'+general_form.carelabel.url" style="width:100%;height:100%"/>
              <CInput
                  addLabelClasses="required"
                  placeholder="height"
                  type="hidden"
                  v-model="general_form.carelabel.url"
                  name="carelabel_image"
                  id="carelabel_image"
              >
              </CInput>
            </div>
            <div class="col-md-3 ">
              <b-button @click="removeCarelabel(general_form.carelabel.file_id)" variant="danger">Remove Logo</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label-for="merchant_billing_name">
                <label class="required">Invoice Account Name</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <label class="custom-radio align-items-start" for="merchant_billing_name">
                <div class="w-100">
                  <template>
                    <div class="d-flex flex-column">
                      <CInput
                          type="text"
                          id="merchant_billing_name"
                          name="merchant_billing_name"
                          v-model="merchant_billing_email.name"
                          addLabelClasses="'required py-2'"
                      ></CInput>
                    </div>
                  </template>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label-for="merchant_billing_email">
                <label class="required">Invoice Account Email</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <label class="custom-radio align-items-start" for="merchant_billing_email">
                <div class="w-100">
                  <template>
                    <div class="d-flex flex-column">
                      <CInput
                          type="text"
                          id="merchant_billing_email"
                          name="merchant_billing_email"
                          v-model="merchant_billing_email.email"
                          addLabelClasses="'required py-2'"
                      ></CInput>
                    </div>
                  </template>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label-for="moq">
                <label>Mixed cart minimum quantity (MOQ)</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <label class="custom-radio align-items-start" for="moq">
                <div class="w-100">
                  <template>
                    <div class="d-flex flex-column">
                      <CInput
                          type="number"
                          id="moq"
                          name="moq"
                          v-model="general_form.moq"
                          addLabelClasses="'required py-2'"
                      ></CInput>
                    </div>
                  </template>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <template v-if="company">
         <template>
             <div class="row mt-2" >
                 <div class="col-12">
                     <div class="row">
                         <div class="col-md-3 my-1">
                             <b-form-group id="currency" label-for="currency">
                                 <label class="required">Display MSRP in builder</label>
                             </b-form-group>
                         </div>
                         <div class="col-md-6 my-1">
                             <b-form-group id="currency" label-for="currency">
                                 <b-form-checkbox @change="checkQuoteStatus()" v-model="display_msrp_in_builder" name="check-button" switch></b-form-checkbox>
                             </b-form-group>
                         </div>
                     </div>
                 </div>
             </div>
             <div class="row mt-2" v-if="display_msrp_in_builder">
                 <div class="col-12">
                     <div class="row">
                         <div class="col-md-3 my-1">
                             <b-form-group id="currency" label-for="currency">
                                 <label class="required">Currency</label>
                             </b-form-group>
                         </div>
                         <div class="col-md-6 my-1">
                             <b-form-group id="currency" label-for="currency">
                                 <v-select :clearable="false"
                                          multiple
                                           id="currency"
                                           :options="currencies"
                                           name="currency"
                                           v-model="general_form.currency"
                                           placeholder="Select Default Currency"
                                 />
                             </b-form-group>
                         </div>
                     </div>
                 </div>
             </div>
           <div class="row mt-2"  v-if="display_msrp_in_builder">
             <div class="col-12">
               <div class="row">
                 <div class="col-md-3">
                   <b-form-group id="currency" label-for="msrp_label">
                     <label class="required">MSRP Label</label>
                   </b-form-group>
                 </div>
                 <div class="col-md-3">
                   <div class="d-flex align-items-center" style="gap:10px">
                     <label class="custom-radio align-items-start" for="msrp_label_1">
                       <div class="mt-2">
                         <input type="radio" id="msrp_label_1" name="msrp_label" :value="false" v-model="general_form.msrp_label.is_custom_msrp_label" />
                         <span class="radio_icon"></span>
                       </div>
                       <div class="radio_text mt-2"><div class="d-flex flex-column">{{ general_form.msrp_label.msrp_label_admin }}</div></div>
                     </label>
                   </div>
                 </div>
                 <div class="col-md-3">
                   <label class="custom-radio align-items-start" for="msrp_label_2">
                      <div class="mt-2">
                       <input type="radio" id="msrp_label_2" name="msrp_label" :value="true" v-model="general_form.msrp_label.is_custom_msrp_label" />
                       <span class="radio_icon"></span>
                     </div>
                      <div class="radio_text w-100" @click="() => general_form.msrp_label.is_custom_msrp_label = true">
                     <template v-if="general_form.msrp_label.is_custom_msrp_label">
                       <div class="d-flex flex-column">
                         <CInput
                             type="text"
                             id="msrp_label"
                             name="msrp_label"
                             v-model="general_form.msrp_label.msrp_label"
                             addLabelClasses="'required py-2'"
                             :readonly="!general_form.msrp_label.is_custom_msrp_label"
                             v-validate="'required'"
                         ></CInput>
                         <div v-if="errors && errors.first('msrp_label')" class="error_msg my-2">
                           {{ errors.first('msrp_label') }}
                         </div>
                       </div>
                     </template>
                     <template v-else>
                       <CInput
                           type="text"
                           id="msrp_label"
                           name="msrp_label"
                           v-model="general_form.msrp_label.msrp_label"
                           addLabelClasses="'required py-2'"
                           :readonly="!general_form.msrp_label.is_custom_msrp_label"
                       ></CInput>
                     </template>
                   </div>
                   </label>
                 </div>
               </div>
             </div>
           </div>
         </template>
        <template v-if="company && company.platform == 'shopify'">
          <hr>
          <fieldset>
            <legend>Shopify</legend>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label>Access Token</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.shopify_setting.shopify_token"
                        placeholder="Enter shopify access token"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Shopify store</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.shopify_setting.shopify_store"
                        placeholder="Enter shopify store"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label>Shopify client id</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.shopify_setting.shopify_client_id"
                        placeholder="Enter shopify client id"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label>Shopify client secret</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.shopify_setting.shopify_client_secret"
                        placeholder="Enter shopify client secret"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr>
        </template>

        <template v-if="company && company.platform == 'bigcommerce'">
          <hr>
          <fieldset>
            <legend>BigCommerce</legend>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Store Hash</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.bigcommerce_setting.store_hash"
                        placeholder="Enter Store Hash"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Client ID</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.bigcommerce_setting.client_id"
                        placeholder="Enter Client ID"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Client Secret</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.bigcommerce_setting.client_secret"
                        placeholder="Enter Client Secret"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Access Token</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.bigcommerce_setting.access_token"
                        placeholder="Enter Access token"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Storefront URL</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.bigcommerce_setting.storefront_url"
                        placeholder="Enter Store front url"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
         </fieldset>
          <hr>
        </template>

        <template v-if="company && company.platform == 'wordpress'">
          <hr>
          <fieldset>
            <legend>Woocommerce</legend>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Customer Order Link</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.woocommerce_customer_order_link"
                        placeholder="Enter Customer Order Link"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">API Username</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.woocommerce_setting.api_username"
                        placeholder="Enter woocommerce api username"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">API Password</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.woocommerce_setting.api_password"
                        placeholder="Enter woocommerce api password"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">API Store URL</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.woocommerce_setting.api_store_url"
                        placeholder="Enter woocommerce api store url"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Admin Authentication URL</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.woocommerce_setting.admin_auth_url"
                        placeholder="Enter woocommerce admin authenticaion url"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-3 my-1">
                    <b-form-group>
                      <label class="required">Custimoo Plugin Api Secret</label>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 my-1">
                    <b-form-input
                        type="text"
                        v-model="general_form.woocommerce_setting.custimoo_plugin_api_secret"
                        placeholder="Enter custimoo plugin api secret"
                    >
                    </b-form-input>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr>
        </template>
      </template>
      <div class="row mt-4">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group id="currency" label-for="msrp_label">
                <label class="required">Collection Background</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <div class="row">
                <template v-for="(collection_image, index) in collection_images">
                  <template v-if="index < 3">
                    <CollectionImageUploader :index="index" :key="`super-admin-collection-${index}`" :collectionImage="collection_image"
                                             :editable="false"
                                             @handleImageSubmission="imageSubmitted"
                                             @clearSelectionExcept="handleClearSelection"
                                             :selection_index="merchant_collection.selection_index"
                    />
                  </template>
                  <template v-else>
                    <CollectionImageUploader :index="index" :key="`merchant-collection-${index}`" :collectionImage="collection_image"
                                             :editable="merchant_collection.selection_index === index"
                                             @handleImageSubmission="imageSubmitted"
                                             @clearSelectionExcept="handleClearSelection"
                                             :selection_index="merchant_collection.selection_index"
                    />
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
          <div class="col-12">
            <h5 class="mb-3">Localization</h5>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <div class="row">
              <div class="col-md-3 my-1">
                <b-form-group id="color_type" label-for="color_type">
                  <label class="required">Set available languages</label>
                </b-form-group>
              </div>
              <div class="col-md-6 my-1">
                <b-form-group id="color_type" label-for="color_type">
                  <v-select :clearable="false"
                            id="languages"
                            :options="supported_languages"
                            name="languages"
                            v-model="general_form.localization.available_languages"
                            placeholder="Select Language"
                            label="name"
                            :loading="language_loading"
                            required="true"
                            multiple
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2" v-if="general_form.localization.available_languages.length > 0">
          <div class="col-12">
            <div class="row">
              <div class="col-md-3 my-1">
                <b-form-group id="color_type" label-for="color_type">
                  <label class="required">Set default language</label>
                </b-form-group>
              </div>
              <div class="col-md-6 my-1">
                <b-form-group id="color_type" label-for="color_type">
                  <v-select :clearable="false"
                            id="default_language"
                            :options="general_form.localization.available_languages"
                            name="default_language"
                            v-model="general_form.localization.default_language"
                            placeholder="Select Default Language"
                            label="name"
                            :loading="language_loading"
                            required="true"
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

      <div class="row">
      <div class="col-9 my-2">
        <div class="row my-3 align-items-right">
          <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
            <button class="btn btn-primary" @click.prevent="submit">Save</button>
          </div>
        </div>
      </div>
    </div>
    </template>
    <template v-if="$can('view-factory-settings')">
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="vector_image_required">
                <label class="required">Vector Image Required</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="vector_image_required" >
                <v-select :clearable="false"
                    id="vector_image_required"
                    :options="vector_image_options"
                    name="vector_settings"
                    v-model="factory_form.vector_image_required"
                    placeholder="Vector Image Required or Not"
                />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="sharepoint_site">
                <label class="required">Sharepoint Site</label>
              </b-form-group>
            </div>
            <div class="col-md-5 my-1">
              <b-form-group id="sharepoint_site" >
                <b-form-input
                    type="text"
                    id="sharepoint_site_required"
                    name="sharepoint_site"
                    @input="markDirty('site')"
                    :class="factory_form.sharepoint.site.verified? 'verified': ''"
                    v-model="factory_form.sharepoint.site.value.name"
                    :disabled="true"
                    placeholder="Sharepoint site is required"
                />
              </b-form-group>
            </div>
            <div class="col-1 my-1">
              <div class="row align-items-right">
                <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
                  <button class="btn" :class="factory_form.sharepoint.site.verified?'btn-success':'btn-primary'"
                          :disabled="true" @click.prevent="verifySharepoint('site')">
                    {{factory_form.sharepoint.site.verified?'Verified':'Verify'}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="sharepoint_target_library">
                <label class="required">Sharepoint Target Library</label>
              </b-form-group>
            </div>
            <div class="col-md-5 my-1">
              <b-form-group id="sharepoint_target_library" >
                <b-form-input
                    type="text"
                    id="sharepoint_target_library_required"
                    name="sharepoint_target_library"
                    @input="markDirty('target_library')"
                    :class="factory_form.sharepoint.target_library.verified? 'verified': ''"
                    v-model="factory_form.sharepoint.target_library.value.name"
                    :disabled="true"
                    placeholder="Sharepoint Target Library required"
                />
              </b-form-group>
            </div>
            <div class="col-1 my-1">
              <div class="row align-items-right">
                <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
                  <button class="btn" :class="factory_form.sharepoint.target_library.verified?'btn-success':'btn-primary'"
                          :disabled="true" @click.prevent="verifySharepoint('target_library')">
                    {{factory_form.sharepoint.target_library.verified?'Verified':'Verify'}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="sharepoint_basepath">
                <label class="required">Sharepoint Basepath</label>
              </b-form-group>
            </div>
            <div class="col-md-5 my-1">
              <b-form-group id="sharepoint_basepath" >
                <b-form-input
                    type="text"
                    id="sharepoint_basepath_required"
                    name="sharepoint_basepath"
                    @input="markDirty('basepath')"
                    :class="factory_form.sharepoint.basepath.verified? 'verified': ''"
                    v-model="factory_form.sharepoint.basepath.value.name"
                    :disabled="true"
                    placeholder="Sharepoint Basepath required"
                />
              </b-form-group>
            </div>
            <div class="col-1 my-1">
              <div class="row align-items-right">
                <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
                  <button class="btn" :class="factory_form.sharepoint.basepath.verified?'btn-success':'btn-primary'"
                          :disabled="true" @click.prevent="verifySharepoint('basepath')">
                    {{factory_form.sharepoint.basepath.verified?'Verified':'Verify'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" >
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="enable_qarma">
                <label class="required">Enable Quality Control</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group label-for="enable_qarma">
                <b-form-checkbox id="enable_qarma" v-model="factory_form.enable_qarma" switch/>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-9 my-2">
          <div class="row my-3 align-items-right">
            <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
              <button class="btn btn-primary" @click.prevent="submit">Save</button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="$can('view-superadmin-settings')">
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label-for="msrp_label">
                <label class="required">MSRP Label</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <label class="custom-radio align-items-start" for="msrp_label_admin">
                <div class="w-100">
                  <template>
                    <div class="d-flex flex-column">
                      <CInput
                          type="text"
                          id="msrp_label_admin"
                          name="msrp_label_admin"
                          v-model="general_form.msrp_label.msrp_label_admin"
                          addLabelClasses="'required py-2'"
                          v-validate="'required'"
                      ></CInput>
                      <div v-if="errors && errors.first('msrp_label_admin')" class="error_msg my-2">
                        {{ errors.first('msrp_label_admin') }}
                      </div>
                    </div>
                  </template>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label-for="api_key_admin">
                <label>API Key</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <label class="custom-radio align-items-start" for="api_key_admin">
                <div class="w-100">
                  <template>
                    <div class="d-flex flex-row">
                        <CInput
                            :class="'flex-grow-1 mr-2'"
                            type="text"
                            id="api_key_admin"
                            name="api_key_admin"
                            v-model="general_form.api_key_admin"
                            :addInputClasses="'py-2'"
                            disabled="true"
                            :ref="'api_key_admin'"
                        ></CInput>
                        <CButton type="button" color="primary"  @click="generateApiKey">Generate</CButton>
                        <CButton type="button" color="primary" variant="outline" @click="revokeApiKey">Revoke</CButton>
                    </div>
                  </template>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" >
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="testing_mode">
                <label class="required">Staging Test Mode</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="testing_mode" label-for="testing_mode">
                <b-form-checkbox v-model="general_form.testing_mode" name="testing_mode" switch></b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group id="currency" label-for="msrp_label">
                <label class="required">Collection Background</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <div class="row">
                <template v-for="(collection_image, index) in collection_images">
                  <CollectionImageUploader :index="index" :key="index" :collectionImage="collection_image" :editable="true" @handleImageSubmission="imageSubmitted"/>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3">
              <b-form-group id="currency" label-for="msrp_label">
                <label class="required">Shop Cover Photos</label>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <div class="row">
                <template v-for="(shopCoverPhoto, shopCoverPhotoIndex) in shopCoverPhotos">
                  <CollectionImageUploader :index="shopCoverPhotoIndex" :key="`shop-cover-photo-${shopCoverPhotoIndex}`" :editable="true" :isShop="true"
                   :collectionImage="shopCoverPhoto"
                  @handleImageSubmission="imageSubmitted({...$event, is_shop_cover_photo: true})"/>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-3 my-1">
              <b-form-group label-for="copied_order_unassigned_alert_recipients">
                <label>Copied Order Alert Recipients</label>
              </b-form-group>
            </div>
            <div class="col-md-6 my-1">
              <b-form-group id="copied_order_unassigned_alert_recipients" label-for="copied_order_unassigned_alert_recipients">
                <v-select :clearable="false"
                    multiple
                    id="copied_order_unassigned_alert_recipients"
                    :options="copied_order_alert_recipient_options"
                    name="copied_order_unassigned_alert_recipients"
                    v-model="general_form.copied_order_unassigned_alert_recipients"
                    placeholder="Select Recipients"
                />
                <small class="form-text text-muted">These users are emailed when a copied order is created without an Order Admin.</small>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-9 my-2">
          <div class="row my-3 align-items-right">
            <div class="d-flex" style="justify-content: flex-end; width: 100%; padding-right: 15px">
              <button class="btn btn-primary" @click.prevent="submit">Save</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Stripe Connect (PBI 13952) — merchant-level payment onboarding.
         Gated to the merchant role only: a Stripe connected account
         belongs to the Company itself, so non-merchant roles
         (SuperAdmin, Manager, SalesRepresentative, …) seeing the
         onboarding controls would be confusing — they cannot act on
         someone else's payment provider from here. The role name for
         the merchant in this admin app is the literal "admin" (see
         ManualOrder.vue::isMerchant for the established convention). -->
    <stripe-connect-section v-if="isMerchant" />

    <b-modal id="necktag_logo_modal" size="lg" no-close-on-backdrop  hide-footer>
      <template #modal-title>
        <span>File Manager</span>
      </template>
      <!--          <ValidationProvider rules="required" v-slot="{ errors }">-->
      <asset-selector :selectedImage="addNeckTagLogo" :fileType="'logo'"></asset-selector>
      <!--          </ValidationProvider>-->

    </b-modal>
    <b-modal id="carelabel_modal" size="lg" no-close-on-backdrop  hide-footer>
      <template #modal-title>
        <span>File Manager</span>
      </template>
      <!--          <ValidationProvider rules="required" v-slot="{ errors }">-->
      <asset-selector :selectedImage="addCarelabel" :fileType="'logo'"></asset-selector>
      <!--          </ValidationProvider>-->

    </b-modal>
  </CCardBody>

</template>
<script>
import CollectionImageUploader from "@/components/CollectionImageUploader.vue";
import StripeConnectSection from "@/views/settings/components/StripeConnectSection.vue";
import { http } from "@/config/httpCommon";
import { isEcommercePlatform, santaClone } from "@/helpers/Helpers";
import Vue from 'vue';
import {find} from "lodash"

export default {
  name: 'GeneralSettings',
  components:{
    CollectionImageUploader,
    StripeConnectSection
  },
  async created() {
    try{

      let res = await http.get(`list-users?user_type=admin`);
      const optionArray = [];
      res.data.map(function (obj) {
        optionArray.push({id: obj.email, label: obj.email});
      })
      this.user_recipients_options = optionArray
      if(this.$can('view-superadmin-settings')){
        // role/users returns an empty list unless roles are requested explicitly
        let alertRecipientsRes = await http.get(`role/users?role[]=superAdmin&role[]=limitedSuperAdmin&role[]=leadOrderAdministrator&role[]=orderAdministrator`);
        const alertRecipientOptionArray = [];
        const adminUsers = (alertRecipientsRes.data && alertRecipientsRes.data.result && alertRecipientsRes.data.result.users) || [];
        adminUsers.forEach(function (user) {
          alertRecipientOptionArray.push({id: user.id, label: user.name});
        })
        this.copied_order_alert_recipient_options = alertRecipientOptionArray
      }
      this.$store.dispatch('currencies').then((currencies)=>{
        currencies.forEach(currency => {
          this.currencies.push({id:currency.code, label:currency.code});
        });
      });
      this.$store.dispatch('countries');
      await this.getGeneralSettings();
      this.company = this.$store.getters.company;

    }catch(err){
      this.showToast(err, 'DANGER');
    }
  },
  data(){
    return {
      base_url: process.env.VUE_APP_FILE_URL,
      merchant_billing_email:{
        email: null,
        name: null
      },
      general_form: {
        measurement_unit: {id:'cm', label: 'Centimeters'},
        color_type:{id:'pantone-tcx', label:'Pantone TCX'},
        logo_color_type:{id:'pantone-tcx', label:'Pantone TCX'},
        allow_custom_color: true,
        ship_only_to_store: false,
        store_address: {
          first_name: '',
          last_name: '',
          email: '',
          address1: '',
          address2: '',
          phone_number: '',
          city:'',
          company_name: '',
          state:'',
          zip_code:'',
          country:59,
        },
        piping_text: null,
        necktag_logo: {url:'', file_id:''},
        carelabel: {url: '', file_id: ''},
        mail_recipients:[],
        quote_recipients:[],
        get_quote: false,
        cart_with_quote: false,
        shopify_setting:{
          shopify_token:null,
          shopify_store:null,
          shopify_client_id:null,
          shopify_client_secret:null
        },
        woocommerce_setting: {
          api_username:null,
          api_password:null,
          api_store_url:null,
          admin_auth_url:null,
          custimoo_plugin_api_secret:null,
        },
        bigcommerce_setting: {
          store_hash:null,
          client_id:null,
          client_secret:null,
          access_token:null,
          storefront_url:null
        },
        woocommerce_customer_order_link:null,
        localization: {
          available_languages: [],
          default_language: { name: "English", short_code: "en" },
        },
        currency: [],
        allow_shuffle_colors:false,
        auto_order_approval: false,
        msrp_label:{
          is_custom_msrp_label: false,
          msrp_label:"",
          msrp_label_admin: ""
        },
        api_key_admin:null,
        moq:0,
        testing_mode:false,
        copied_order_unassigned_alert_recipients:[],
      },
      factory_form:{
        vector_image_required:{id:false, label:'No'},
        sharepoint:{
          site:{
            value: {
              name: null,
              siteId:null,
            },
            verified:false,
          },
          target_library:{
            value: {
              name: null,
              driveId: null,
            },
            verified:false,
          },
          basepath:{
            value: {
              name: null
            },
            verified:false,
          },
        },
        enable_qarma:false,
      },
      unit_labels:{
          measurement_unit: {
            cm:'Centimeters',
            in:'Inches'
          }
      },
      color_type_options:[{id:'pantone-tcx', label:'Pantone TCX'},{id:'cmyk', label:'CMYK'},{id:'product_color', label:'Product Color'},{id:'pantone-coated', label:'Pantone Coated'}],
      user_recipients_options : [],
      copied_order_alert_recipient_options : [],
      vector_image_options:[{id:true,label:'Yes'},{id:false,label:'No'}],
      company:null,
      supported_languages: [],
      currencies:[],
      language_loading: true,
      display_msrp_in_builder: false,
      imageUploaded:"",
      imageSrc:null,
      collection_images:[
        {
          index: 0,
          img_url: null,
          full_width: null,
          dimension: {
            width: null,
            height: null
          }
        },
        {
          index: 1,
          img_url: null,
          full_width: null,
          dimension: {
            width: null,
            height: null
          }
        },
        {
          index: 2,
          img_url: null,
          full_width: null,
          dimension: {
            width: null,
            height: null
          }
        }
      ],
      merchant_collection:{
        is_custom_collection:false,
        selection_index:null,
        collection: [{
          index: 0,
          img_url: null,
          full_width: true,
          dimension: {
            width: null,
            height: null
          }
        }]
      },
      shopCoverPhotos: null
    }
  },
  computed:{
    userRole:function(){
      return this.$store.getters.role;
    },
    /**
     * Whether the logged-in user is a merchant. Drives the visibility of
     * the Stripe Connect onboarding section — only the merchant role
     * should be able to connect / disconnect their Stripe account.
     * Same convention as ManualOrder.vue::isMerchant: the merchant role
     * is stored under the literal name "admin" in this admin app.
     */
    isMerchant() {
      return this.$store.getters.roleName === 'admin';
    },
    getCurrencies(){
      return this.$store.getters.getCurrencies;
    },
    getCountries() {
      return this.$store.getters.getCountries;
    }
  },
  methods: {
    santaClone,
    isEcommercePlatform,
    async submit(){

      //Validation for collection images
      if(this.$can("view-general-settings")){
        if(this.merchant_collection.is_custom_collection){
          let collection = this.merchant_collection.collection[0];
          if(!collection.img_url){
              this.showToast("Please upload collection image","ERROR");
              return;
          }
          // Check if full_width is false and dimensions are null
          if (!collection.full_width && ((collection.dimension.width === null || collection.dimension.height === null) || (collection.dimension.width === "" || collection.dimension.height === ""))) {
            this.showToast("Please fill width and height","ERROR");
            return;
          }

        }

        if (this.general_form.get_quote && this.general_form.quote_recipients.length < 1) {
          this.showToast("Please add get a quote recipient.","ERROR");
          return;
        }
        if(this.general_form.moq < 0){
          this.showToast("MOQ should be non negative number","ERROR");
          return;
        }
        if (this.general_form.ship_only_to_store) {
          const storeAddress = this.general_form.store_address;
          const excludedFields = ['company_name', 'state', 'address2'];

          for (let key in storeAddress) {
            if (!excludedFields.includes(key) && storeAddress[key] === '') {
              this.showToast("Please fill in all required store address fields.", "ERROR");
              return;
            }
          }
        }
      }
      if(this.$can("view-superadmin-settings")){
        let valid = false;
        this.collection_images.forEach(collection => {
          // Check if img_url is empty
          if (!collection.img_url) {
            valid = true;
            this.showToast(`Please upload collection image for index ${collection.index}!`,"ERROR");
            return;
          }

          // Check if full_width is false and dimensions are null
          if (collection.full_width === false && ((collection.dimension.width === null || collection.dimension.height === null) || (collection.dimension.width === "" || collection.dimension.height === ""))) {
            valid = true;
            this.showToast(`Please fill width and height for index ${collection.index}!`,"ERROR");
            return;
          }
        });
        if(valid){
          return
        }
      }
      if(this.$can("view-factory-settings")){
        let valid = false;
        if(this.sharepointValidation()){
            valid = false;
        }
        else {
          valid = true;
        }
        if(valid){
          return
        }
      }
      let valid = await this.$validator.validate();
      if(valid){
        await this.$store.commit('set', ['showLoader', true]);
        try{
          let settings = [];

          if(this.$can('view-general-settings')) {
              settings.push({key: 'localization', value: this.general_form.localization})
              let mail_receipients = this.general_form.mail_recipients.map(obj => obj.label)
              let quote_receipients = this.general_form.quote_recipients.map(obj => obj.label)
              let currencies = this.general_form.currency.map(obj => obj.label)
              settings.push({
                key: 'measurement_unit', value: {
                  unit: this.general_form.measurement_unit.id,
                  conversion_operator: this.general_form.measurement_unit.id === 'cm' ? 'multiply' : 'divide',
                  conversion_value: this.general_form.measurement_unit.id === 'cm' ? 1 : 2.54,

                }
              });
              settings.push({key: 'color_type', value: this.general_form.color_type.id})
              settings.push({key: 'allow_custom_color', value: this.general_form.allow_custom_color})
              settings.push({key: 'allow_shuffle_colors', value: this.general_form.allow_shuffle_colors})
              settings.push({key: 'logo_color_type', value: this.general_form.logo_color_type.id})
              settings.push({key: 'mail_receipients', value: mail_receipients})
              settings.push({key: 'currencies', value: {...{currencies:currencies}, ...{visible: this.display_msrp_in_builder}}})
              settings.push({key:'piping_text', value:this.general_form.piping_text})
              settings.push({key:'necktag_logo', value:this.general_form.necktag_logo})
              settings.push({key:'carelabel', value:this.general_form.carelabel})
              settings.push({key:'msrp_label', value: {is_custom_msrp_label: this.general_form.msrp_label.is_custom_msrp_label, msrp_label: this.general_form.msrp_label.msrp_label}})
              settings.push({key:'collection_image_merchant', value: this.merchant_collection});
              settings.push({key:'merchant_billing_email', value: this.merchant_billing_email});
              settings.push({key:'moq', value: this.general_form.moq});
              settings.push({key:'get_quote', value: {...{receipients:quote_receipients}, ...{enable: this.general_form.get_quote, cart_with_quote:this.general_form.cart_with_quote}}});
              settings.push({key:'ship_only_to_store', value: this.general_form.ship_only_to_store});
              settings.push({key: 'store_address', value: this.general_form.store_address});
              settings.push({key: 'auto_order_approval', value: this.general_form.auto_order_approval});

            if(this.general_form.shopify_setting.shopify_store != null && 
              (this.general_form.shopify_setting.shopify_token != null || 
              this.general_form.shopify_setting.shopify_client_id != null && 
              this.general_form.shopify_setting.shopify_client_secret != null)) {
                settings.push({key:'shopify_setting', value:this.general_form.shopify_setting})
              }

              if(this.company && this.company.platform == 'wordpress') {
                if (this.general_form.woocommerce_setting.api_username != null
                    && this.general_form.woocommerce_setting.api_password != null
                    && this.general_form.woocommerce_setting.api_store_url != null
                ) {
                  settings.push({key: 'woocommerce_setting', value: this.general_form.woocommerce_setting})
                }
                settings.push({key:"woocommerce_customer_order_link", value: this.general_form.woocommerce_customer_order_link});
              }

            if(this.company && this.company.platform == 'bigcommerce') {
              if (this.general_form.bigcommerce_setting.store_hash != null
                  && this.general_form.bigcommerce_setting.client_id != null
                  && this.general_form.bigcommerce_setting.client_secret != null
                  && this.general_form.bigcommerce_setting.access_token != null
              ) {
                settings.push({key: 'bigcommerce_setting', value: this.general_form.bigcommerce_setting})
              }

            }

          }
          else if(this.$can('view-factory-settings')) {
            settings.push({key:'vector_image_constraint', value: this.factory_form.vector_image_required.id })
            settings.push({key:'enable_qarma', value: this.factory_form.enable_qarma })
            if(!this.IsSharePointValuesNull()){
              settings.push({key:'sharepoint_site', value: this.factory_form.sharepoint.site })
              settings.push({key:'sharepoint_target_library', value: this.factory_form.sharepoint.target_library })
              settings.push({key:'sharepoint_basepath', value: this.factory_form.sharepoint.basepath })
            }
          }
          else if(this.$can('view-superadmin-settings')) {
            settings.push({key:'collection_image_admin', value: JSON.stringify(this.collection_images)})
            settings.push({key:'msrp_label_admin', value: this.general_form.msrp_label.msrp_label_admin })
            settings.push({key:'testing_mode', value: this.general_form.testing_mode })
            if(this.general_form.api_key_admin){
              settings.push({key:'api_key_admin', value: this.general_form.api_key_admin })
            }
            settings.push({key:'copied_order_unassigned_alert_recipients', value: this.general_form.copied_order_unassigned_alert_recipients.map(obj => obj.id) })
          }
          settings.push({key:'shop_default_cover_photos', value: this.shopCoverPhotos})
          let payload = {settings};
          let res = await this.$store.dispatch('saveConfiguration', payload);
          console.log("sss", payload)
          if(res.data.status_code === 200){
            this.showToast('Configuration saved successfully', 'SUCCESS');
          }else{
            this.showToast('Something went wrong', 'ERROR')
          }
          this.$store.commit('set', ['showLoader', false]);
        }catch(err){
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
    },
    async getGeneralSettings() {
      await this.$store.commit('set', ['showLoader', true]);
      try{
        var self = this;
        let res = await this.$store.dispatch('getConfigurations');
        if(res.data.status_code === 200){
          this.supported_languages = res.data.result.supported_languages || []
          if (res.data.result.localization && res.data.result.localization.value) {
            if (res.data.result.localization.value.available_languages) {
              this.general_form.localization.available_languages = res.data.result.localization.value.available_languages
            }
            this.general_form.localization.default_language = res.data.result.localization.value.default_language
          }
          this.language_loading = false
          let shopDefaultCoverPhotos = find(res.data.result.settings, function(setting) {
            return setting.key_name === "shop_default_cover_photos"
          })
          if(shopDefaultCoverPhotos) {
            this.shopCoverPhotos = shopDefaultCoverPhotos.value
          } else {
            this.shopCoverPhotos = [this.getShopCoverPhotosDefaultObject(0), this.getShopCoverPhotosDefaultObject(1), this.getShopCoverPhotosDefaultObject(2)]

          }
          res.data.result.settings.forEach((setting)=> {
            if(this.$can('view-general-settings')){
              if(setting.key_name == "measurement_unit" )
              {
                let label = this.unit_labels.measurement_unit[setting.value.unit];
                self.general_form.measurement_unit = {
                  id: setting.value.unit,
                  label: label
                }
              }
              else if(setting.key_name == "color_type" )
              {

                let selected_option = this.color_type_options.filter(obj=> obj.id == setting.value);
                self.general_form.color_type.id = selected_option[0].id
                self.general_form.color_type.label =  selected_option[0].label
              }
              else if(setting.key_name == "piping_text") {
                self.general_form.piping_text = setting.value
              }
              else if(setting.key_name == "necktag_logo") {
                if(setting.value.url)
                  self.general_form.necktag_logo.url =  setting.value.url
                if(setting.value.file_id)
                  self.general_form.necktag_logo.file_id =  setting.value.file_id
              }
              else if(setting.key_name == "carelabel") {
                if(setting.value.url)
                  self.general_form.carelabel.url =  setting.value.url
                if(setting.value.file_id)
                  self.general_form.carelabel.file_id =  setting.value.file_id
              }
              else if(setting.key_name == "ship_only_to_store") {
                  self.general_form.ship_only_to_store =  setting.value;
              }
              else if(setting.key_name == "store_address") {
                self.general_form.store_address =  setting.value;
              }
              else if(setting.key_name == "logo_color_type" )
              {
                let selected_option = this.color_type_options.filter(obj=> obj.id == setting.value);
                self.general_form.logo_color_type.id = selected_option[0].id
                self.general_form.logo_color_type.label =  selected_option[0].label
              }
              else if(setting.key_name == "allow_custom_color"){
                if(setting.value === "true"){
                  self.general_form.allow_custom_color = setting.value === "true" ? true: false;
                }
                else if(setting.value === true){
                  self.general_form.allow_custom_color = setting.value === true ? true: false;
                }
                else {
                  self.general_form.allow_custom_color = false;
                }
              }
              else if(setting.key_name == "shopify_setting" )
              {
                if(setting.value.shopify_token)
                self.general_form.shopify_setting.shopify_token =  setting.value.shopify_token
                if(setting.value.shopify_store)
                self.general_form.shopify_setting.shopify_store =  setting.value.shopify_store
                if(setting.value.shopify_client_id)
                self.general_form.shopify_setting.shopify_client_id = setting.value.shopify_client_id                
                if(setting.value.shopify_client_secret)
                self.general_form.shopify_setting.shopify_client_secret = setting.value.shopify_client_secret
              }
              else if(setting.key_name == "woocommerce_setting" )
              {
                if(setting.value.api_username)
                  self.general_form.woocommerce_setting.api_username =  setting.value.api_username
                if(setting.value.api_password)
                  self.general_form.woocommerce_setting.api_password =  setting.value.api_password
                if(setting.value.api_store_url)
                  self.general_form.woocommerce_setting.api_store_url =  setting.value.api_store_url
                if(setting.value.admin_auth_url)
                  self.general_form.woocommerce_setting.admin_auth_url =  setting.value.admin_auth_url
                if(setting.value.custimoo_plugin_api_secret)
                  self.general_form.woocommerce_setting.custimoo_plugin_api_secret =  setting.value.custimoo_plugin_api_secret
              }
              else if(setting.key_name == "bigcommerce_setting" )
              {
                if(setting.value.client_id)
                  self.general_form.bigcommerce_setting.client_id =  setting.value.client_id
                if(setting.value.client_secret)
                  self.general_form.bigcommerce_setting.client_secret =  setting.value.client_secret
                if(setting.value.store_hash)
                  self.general_form.bigcommerce_setting.store_hash =  setting.value.store_hash
                if(setting.value.access_token)
                  self.general_form.bigcommerce_setting.access_token =  setting.value.access_token
                if(setting.value.storefront_url)
                  self.general_form.bigcommerce_setting.storefront_url =  setting.value.storefront_url
              }
              else if (setting.key_name == "woocommerce_customer_order_link"){
                if(setting.value){
                  self.general_form.woocommerce_customer_order_link = setting.value;
                }
              }
              else if(setting.key_name == "mail_receipients" ) {
                  setting.value.forEach((email)=>{
                    self.general_form.mail_recipients.push({id: email, label: email})
                  })
              }else if(setting.key_name == "get_quote" ) {
                  self.general_form.get_quote = setting.value.enable;
                  self.general_form.cart_with_quote = setting.value.cart_with_quote;
                  setting.value.receipients.forEach((email)=>{
                    self.general_form.quote_recipients.push({id: email, label: email})
                  })
              }
              else if(setting.key_name == "currencies" ) {
                  if(setting.value){
                      if(Array.isArray(setting.value.currencies) && setting.value.currencies.length > 0){
                        self.general_form.currency = [];
                          for(const currency of setting.value.currencies) {
                              self.general_form.currency.push({id: currency, label: currency})
                          }
                      }
                      self.display_msrp_in_builder =  setting.value.visible               
                }
              }
              else if(setting.key_name == "auto_order_approval"){
                if(setting.value === "true"){
                  self.general_form.auto_order_approval = setting.value === "true" ? true: false;
                }
                else if(setting.value === true){
                  self.general_form.auto_order_approval = setting.value === true ? true: false;
                }
                else {
                  self.general_form.auto_order_approval = false;
                }
              }
              else if(setting.key_name == "msrp_label"){
                if(setting.value){
                  if(setting.value.is_custom_msrp_label)
                    self.general_form.msrp_label.is_custom_msrp_label =  setting.value.is_custom_msrp_label
                  if(setting.value.msrp_label)
                    self.general_form.msrp_label.msrp_label =  setting.value.msrp_label
                  if(setting.value.msrp_label_admin){
                    self.general_form.msrp_label.msrp_label_admin = setting.value.msrp_label_admin
                  }
                }
              }
              else if(setting.key_name == "msrp_label_admin"){
                if(setting.value){
                  if(setting.value){
                    self.general_form.msrp_label.msrp_label_admin = setting.value
                  }
                }
              }
              else if(setting.key_name == "merchant_billing_email"){
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let merchant_billing_email = null;
                  if(isEncoded){
                    merchant_billing_email = JSON.parse(setting.value);
                  }
                  else {
                    merchant_billing_email = setting.value;
                  }
                  self.merchant_billing_email.email = merchant_billing_email.email;
                  self.merchant_billing_email.name = merchant_billing_email.name;
                }
              }
              if(setting.key_name == "collection_image_admin"){
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let collectionImages = null;
                  if(isEncoded){
                    collectionImages = JSON.parse(setting.value);
                  }
                  else {
                    collectionImages = setting.value;
                  }
                  self.collection_images.map((collection_image, index) => {
                        if(index < 3){
                              collection_image.full_width = collectionImages[index].full_width,
                              collection_image.img_url = collectionImages[index].img_url,
                              collection_image.index = collectionImages[index].index,
                              collection_image.dimension.width = collectionImages[index].dimension.width;
                              collection_image.dimension.height = collectionImages[index].dimension.height;
                        }
                        return collection_image;
                  });
                }
              }
              if(setting.key_name == "collection_image_merchant"){
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let merchant_collection = null;
                  if(isEncoded){
                    merchant_collection = JSON.parse(setting.value);
                  }
                  else{
                    merchant_collection = setting.value;
                  }
                  this.merchant_collection.is_custom_collection = merchant_collection.is_custom_collection;
                  this.merchant_collection.selection_index = merchant_collection.selection_index;
                  merchant_collection.collection.map((collection,index) => {
                      if(index === 0){
                              this.merchant_collection.collection[0].full_width = collection.full_width,
                              this.merchant_collection.collection[0].img_url = collection.img_url,
                              this.merchant_collection.collection[0].index = collection.index,
                              this.merchant_collection.collection[0].dimension.width = collection.dimension.width;
                              this.merchant_collection.collection[0].dimension.height = collection.dimension.height;
                      }
                  });
                  this.collection_images.push(this.merchant_collection.collection[0]);
                }
              }
              if(setting.key_name == "allow_shuffle_colors"){
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let allow_shuffle_colors = null;
                  if(isEncoded){
                    allow_shuffle_colors = JSON.parse(setting.value);
                  }
                  else{
                    allow_shuffle_colors = setting.value;
                  }
                  if(setting.value === "true"){
                    self.general_form.allow_shuffle_colors = setting.value === "true" ? true: false;
                  }
                  else if(setting.value === true){
                    self.general_form.allow_shuffle_colors = setting.value === true ? true: false;
                  }
                  else {
                    self.general_form.allow_shuffle_colors = false;
                  }
                }
              }
              if(setting.key_name == "moq"){
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let moq = null;
                  if(isEncoded){
                    moq = JSON.parse(setting.value);
                  }
                  else{
                    moq = setting.value;
                  }
                  self.general_form.moq = parseInt(moq);
                }
              }
            }
            else if(this.$can('view-factory-settings')) {
              if (setting.key_name == "vector_image_constraint") {
                let selected_option = this.vector_image_options.filter(obj => obj.id == setting.value);
                self.factory_form.vector_image_required.id = selected_option[0].id
                self.factory_form.vector_image_required.label = selected_option[0].label
              }
              if (setting.key_name == "sharepoint_site") {
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let sharepoint_site = null;
                  if(isEncoded){
                      sharepoint_site = JSON.parse(setting.value);
                  }
                  else{
                    sharepoint_site = setting.value;
                  }
                  self.factory_form.sharepoint.site.verified = this.isVerified(sharepoint_site.verified);
                  self.factory_form.sharepoint.site.value.name = sharepoint_site.value.name;
                  self.factory_form.sharepoint.site.value.siteId = sharepoint_site.value.siteId;
                }
              }
              if (setting.key_name == "sharepoint_target_library") {
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let sharepoint_target_library = null;
                  if(isEncoded){
                    sharepoint_target_library = JSON.parse(setting.value);
                  }
                  else{
                    sharepoint_target_library = setting.value;
                  }
                  self.factory_form.sharepoint.target_library.verified = this.isVerified(sharepoint_target_library.verified);
                  self.factory_form.sharepoint.target_library.value.name = sharepoint_target_library.value.name;
                  self.factory_form.sharepoint.target_library.value.driveId = sharepoint_target_library.value.driveId;
                }
              }
              if (setting.key_name == "sharepoint_basepath") {
                if(setting.value){
                  const isEncoded = this.isJSONString(setting.value);
                  let sharepoint_basepath = null;
                  if(isEncoded){
                    sharepoint_basepath = JSON.parse(setting.value);
                  }
                  else{
                    sharepoint_basepath = setting.value;
                  }
                  self.factory_form.sharepoint.basepath.verified = this.isVerified(sharepoint_basepath.verified);
                  self.factory_form.sharepoint.basepath.value.name = sharepoint_basepath.value.name;
                }
              }
              if (setting.key_name == "enable_qarma") {
                if(setting.value){
                  if(setting.value === "true"){
                    self.factory_form.enable_qarma = setting.value === "true" ? true: false;
                  }
                  else if(setting.value === true){
                    self.factory_form.enable_qarma = setting.value === true ? true: false;
                  }
                  else {
                    self.factory_form.enable_qarma = false;
                  }
                }
              }
            }
            else if(this.$can('view-superadmin-settings')) {
              if (setting.key_name == "msrp_label_admin") {
                if (setting.value) {
                  self.general_form.msrp_label.msrp_label_admin = setting.value

                }
              }
              if (setting.key_name == "testing_mode") {
                  if(setting.value){
                    if(setting.value === "true"){
                      self.general_form.testing_mode = setting.value === "true" ? true: false;
                    }
                    else if(setting.value === true){
                      self.general_form.testing_mode = setting.value === true ? true: false;
                    }
                    else {
                      self.general_form.testing_mode = false;
                    }
                  }
              }
              if (setting.key_name == "collection_image_admin") {
                if (setting.value) {
                  const isEncoded = this.isJSONString(setting.value);
                  let collectionImages = null;
                  if (isEncoded) {
                    collectionImages = JSON.parse(setting.value);
                  } else {
                    collectionImages = setting.value;
                  }
                  self.collection_images.map((collection_image, index) => {
                    collection_image.full_width = collectionImages[index].full_width,
                        collection_image.img_url = collectionImages[index].img_url,
                        collection_image.index = collectionImages[index].index,
                        collection_image.dimension.width = collectionImages[index].dimension.width;
                    collection_image.dimension.height = collectionImages[index].dimension.height;
                    return collection_image;
                  });
                }
              }
              if (setting.key_name == "api_key_admin") {
                if (setting.value) {
                  const isEncoded = this.isJSONString(setting.value);
                  let api_key_admin = null;
                  if (isEncoded) {
                    api_key_admin = JSON.parse(setting.value);
                  } else {
                    api_key_admin = setting.value;
                  }
                  self.general_form.api_key_admin = api_key_admin;
                }
              }
              if (setting.key_name == "copied_order_unassigned_alert_recipients") {
                let recipientIds = setting.value;
                if (typeof recipientIds === "string" && this.isJSONString(recipientIds)) {
                  recipientIds = JSON.parse(recipientIds);
                }
                if (Array.isArray(recipientIds)) {
                  self.general_form.copied_order_unassigned_alert_recipients = recipientIds.map(function (userId) {
                    let matchedOption = self.copied_order_alert_recipient_options.find(function (option) {
                      return option.id === userId;
                    });
                    return matchedOption ? matchedOption : {id: userId, label: `User #${userId}`};
                  });
                } else {
                  self.general_form.copied_order_unassigned_alert_recipients = [];
                }
              }
            }
            else {
              this.showToast('Settings need to be set first', 'ERROR');
            }
        });
        this.$store.commit('set', ['showLoader', false]);
      }
      } catch(err) {
        console.log(err);
        this.$store.commit('set', ['showLoader', false]);
        this.showErrors(err);
      }
    },
    async generateApiKey(){
      let res = await this.$store.dispatch('generateApiKey');
      if(res.data.status_code === 200){
        this.general_form.api_key_admin = res.data.result;
        this.showToast('Api key generated successfully', 'SUCCESS');
      }else{
        this.showToast('Something went wrong', 'ERROR')
      }
    },
    async revokeApiKey(){
      let res = await this.$store.dispatch('revokeApiKey');
      if(res.data.status_code === 200){
        this.general_form.api_key_admin = res.data.result;
        this.showToast('Api key revoked successfully', 'SUCCESS');
      }else{
        this.showToast('Something went wrong', 'ERROR')
      }
    },
    setLogoColorType(e) {
      const selected_option = {...e}

      if (selected_option.id == "product_color") {
        this.general_form.logo_color_type.id = this.color_type_options[0].id
        this.general_form.logo_color_type.label = this.color_type_options[0].label
      } else {
        this.general_form.logo_color_type.id = selected_option.id
        this.general_form.logo_color_type.label = selected_option.label
      }
    },
    addNeckTagLogo(selectedLogo) {
      this.general_form.necktag_logo.url = selectedLogo.file_url;
      this.general_form.necktag_logo.file_id = selectedLogo.id;
      if(this.errors.first('necktag_logo_image'))
      {
         for(let i = 0 ; i < this.errors.items.length ; i++){
          if(this.errors.items[i].field === 'necktag_logo_image'){
            this.errors.items.splice(i,1);
          }
        }
      }
      this.$bvModal.hide('necktag_logo_modal');
    },
    removeNeckTagLogo() {
      this.general_form.necktag_logo = {
        url : '',
        file_id: ''
      }
    },
    addCarelabel(selectedLabel) {
      this.general_form.carelabel.url = selectedLabel.file_url;
      this.general_form.carelabel.file_id = selectedLabel.id;
      if(this.errors.first('carelabel_image'))
      {
        for(let i = 0 ; i < this.errors.items.length ; i++){
          if(this.errors.items[i].field === 'carelabel_image'){
            this.errors.items.splice(i,1);
          }
        }
      }
      this.$bvModal.hide('carelabel_modal');
    },
    removeCarelabel() {
      this.general_form.carelabel = {
        url : '',
        file_id: ''
      }
    },
    imageSubmitted(imageObject){
      const isShopCoverPhoto = imageObject.is_shop_cover_photo
      if(isShopCoverPhoto) {
        delete imageObject.is_shop_cover_photo
        this.shopCoverPhotos[imageObject.index] = imageObject 
      } else {
        this.collection_images[imageObject.index] = imageObject;
        if(imageObject.index === 3){
          this.merchant_collection.collection[0] = imageObject;
          this.merchant_collection.is_custom_collection = true;
        }
        this.merchant_collection.selection_index = imageObject.index;
      }
    },
    handleClearSelection(collection){
      this.merchant_collection.selection_index = collection.index;
      if(collection.index == 3){
        this.merchant_collection.is_custom_collection = true;
      }
      else {
        this.merchant_collection.is_custom_collection = false;
      }
    },
    isJSONString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (error) {
        return false;
      }
    },
    setQuoteRecipients() {
      if(this.general_form.get_quote) {
        this.general_form.quote_recipients = [];
        this.general_form.mail_recipients.forEach((obj) => {
          this.general_form.quote_recipients.push({id:obj.id, label:obj.label});
        })
      }
      this.display_msrp_in_builder = false;
    },
    checkQuoteStatus() {
      if(this.general_form.get_quote && this.display_msrp_in_builder) {
       this.showToast('Msrp cannot be enabled in "get a quote" mode', "Error");
       this.display_msrp_in_builder = false;
      }
    },
    async verifySharepoint(key){
      switch (key) {
        case 'site':
        {
          if(this.factory_form.sharepoint[key].value.name){
            const res = await this.sharepointApi(key, this.factory_form.sharepoint[key].value);
            if(res){
              this.factory_form.sharepoint[key].value.siteId = res.data.result.siteId;
            }
          }
          else{
            this.showToast('Please enter the site name', "Error");
          }
          break;
        }
        case 'target_library':
        {
          if(this.factory_form.sharepoint[key].value.name){
            if(this.factory_form.sharepoint['site'].value.siteId){
              if(this.factory_form.sharepoint['site'].verified){
                const res = await this.sharepointApi(key, this.factory_form.sharepoint['site'].value, this.factory_form.sharepoint[key].value);
                if(res){
                  this.factory_form.sharepoint[key].value.driveId = res.data.result.driveId;
                }
              }
              else {
                this.showToast('Verify Sharepoint site first', "Error");
              }
            }
            else{
              this.showToast('Site Id does not exists, Please verify site again', "Error");
            }
          }
          else {
            this.showToast('Please enter the target library', "Error");
          }
          break;
        }
        case 'basepath':
        {
          if(this.factory_form.sharepoint[key].value.name){
            if(this.factory_form.sharepoint['target_library'].value.driveId){
              if(this.factory_form.sharepoint['site'].verified && this.factory_form.sharepoint['target_library'].verified){
                this.sharepointApi(key, this.factory_form.sharepoint['site'].value, this.factory_form.sharepoint['target_library'].value, this.factory_form.sharepoint[key].value)
              }
              else {
                this.showToast('Verify Sharepoint site first', "Error");
                this.showToast('Verify Sharepoint target library first', "Error");
              }
            }
            else{
              this.showToast('Target library Id does not exists, Please verify target library again', "Error");
            }
          }
          else {
            this.showToast('Please enter the base path', "Error");
          }
          break;
        }
        default:
        {
          this.showToast('Not a valid sharepoint setting', "Error");
          break;
        }
      }
    },
    markDirty(key){
      this.factory_form.sharepoint[key].verified = false;
    },
    async sharepointApi(key, sharepoint_site, sharepoint_target_library = null, sharepoint_basepath = null){
      this.$store.commit('set', ['showLoader', true]);
      let res = await this.$store.dispatch("verifySharepoint", {
        key: key,
        sharepoint_site: {
          site: sharepoint_site.name,
          siteId: sharepoint_site.siteId
        },
        sharepoint_target_library:{
          target_library: sharepoint_target_library?sharepoint_target_library.name: null,
          driveId: sharepoint_target_library? sharepoint_target_library.driveId: null
        },
        sharepoint_basepath: sharepoint_basepath,
      });
      if(res.data.status_code === 200){
        this.factory_form.sharepoint[key].verified = true;
        this.showToast(res.data.message,"SUCCESS");
        this.$store.commit('set', ['showLoader', false]);
        return res;
      }
      else{
        this.factory_form.sharepoint[key].verified = false;
        this.showToast(res.data.message,"Error");
        this.$store.commit('set', ['showLoader', false]);
        return null;
      }
    },
    isVerified(verified) {
      return verified === true || verified === "true" || verified === 1;
    },
    IsSharePointValuesNull(){
      const { site, target_library, basepath } = this.factory_form.sharepoint;
      let isValid = true;
      if((site.value.name === null && target_library.value.name === null && basepath.value.name === null) ||
          (site.value.name === "" && target_library.value.name === "" && basepath.value.name === "") ||
          (site.value.name === "" && target_library.value.name === null && basepath.value.name === null) ||
          (site.value.name === "" && target_library.value.name === "" && basepath.value.name === null)
      ){
        isValid = true;
        return isValid;
      }
    },
    sharepointValidation(){
      const { site, target_library, basepath } = this.factory_form.sharepoint;
      let isValid = true;
      if(this.IsSharePointValuesNull()){
        return isValid;
      }
      //Sharepoint Site Validation
      // if(site.value.name !== null || site.value.name !== ""){
      //   this.showToast("Please enter sharepoint site name","Error");
      //   isValid = false;
      // }
      if(!this.isVerified(site.verified)){
        this.showToast("Please verify sharepoint site name","Error");
        isValid = false;
      }
      if(site.value.siteId === null || site.value.siteId === ""){
        this.showToast("Sharepoint site id does not exists, Please verify sharepoint site name again","Error");
        isValid = false;
      }

      //Sharepoint Target Library Validation
      // if(target_library.value.name !== null || target_library.value.name !== ""){
      //   this.showToast("Please enter sharepoint target library name","Error");
      //   isValid = false;
      // }
      if(!this.isVerified(target_library.verified)){
        this.showToast("Please verify sharepoint target library name","Error");
        isValid = false;
      }
      if(target_library.value.driveId === null || target_library.value.driveId === ""){
        this.showToast("Sharepoint target library id does not exists, Please verify target library name again","Error");
        isValid = false;
      }

      //Sharepoint basepath Validation
      // if(basepath.value.name !== null || basepath.value.name !== ""){
      //   this.showToast("Please enter sharepoint basepath","Error");
      //   isValid = false;
      // }
      if(!this.isVerified(basepath.verified)){
        this.showToast("Please verify sharepoint basepath","Error");
        isValid = false;
      }
      return isValid
    },
    getShopCoverPhotosDefaultObject(index) {
      return {
          index: index ? index : 0,
          img_url: null,
          full_width: true,
          dimension: {
            width: null,
            height: null
          }
        }
    }
  },
}


</script>
<style lang="scss" scoped>
  .verified{
    color: #768192;
    background-color: #FFFFFF;
    border-color: #00ff0b;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 255, 11, 0.5);
  }
  .verified-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: green; /* Change to any color you prefer */
  }
  .button {
    padding: 10px;
    border: none;
    cursor: pointer;
    margin: 5px;
    max-height: 45px;
    transition: background-color 0.3s ease;
  }
  .trash {
    position: absolute;
    right: -40px;
    top: -5px;
  }
    .add_range span, .delete_button span{
        cursor: pointer;
    }
    .delete_button{
        cursor: pointer;
    }
    .custom-radio{
      display: flex;
      align-items: center;
      gap: 10px;

      .radio_text{
        &>*{
          margin:0;
          padding: 0;
        }
      }

      &>div{
        .radio_icon {
          display: block;
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          border: 1px solid #009FE3; /* Green color for the checkmark */
          border-radius: 50%; /* Makes the border circular */
          position: relative;

          /* Rotating the square to create a checkmark */
          transform: rotate(0);
        }

        /* Styling for the checkmark itself */
        .radio_icon::before,
        .radio_icon::after {
          display: none;
          content: '';
          position: absolute;
          background-color: #fff; /* Green color for the checkmark */
        }

        .radio_icon::before {
          width: 6px;
          height: 2px;
          top: 9px;
          left: 3px;
          transform: rotate(45deg);
        }

        .radio_icon::after {
          width: 2px;
          height: 10px;
          top: 4px;
          left: 10px;
          transform: rotate(45deg);
        }

        input{
          display: none;

          &:disabled{
            &+.radio_icon{
              cursor: not-allowed;
              background-color: #eee;
              border-color: #ccc;

              &::before,
              &::after {
                display: block;
                background-color: #eee;
              }
            }
          }

          &:checked{
            &+.radio_icon{
              background-color: #009FE3;

              &::before,
              &::after {
                display: block;
                background-color: #fff;
              }
            }

            &:disabled{
              &+.radio_icon{
                cursor: not-allowed;
                background-color: #ccc;
                border-color: #aaa;

                &::before,
                &::after {
                  display: block;
                  background-color: #fff;
                }
              }
            }
          }
        }
      }

      &.checkbox{
        &>span {
          .radio_icon {
            border-radius: 20%;
          }
        }
      }
    }
</style>
